<template>
  <section class="cart-table">
    <div class="cart-table-wrap content">
      <ul>
        <li class="header ou-flex-center">
          <div class="goods-info">
            <div class="order-cover"></div>
            <div class="order-name">商品信息</div>
            <div class="order-price">售价</div>
          </div>
          <div class="order-pay ou-expand">实付款</div>
          <div class="order-status ou-expand">订单状态</div>
          <div class="order-action ou-expand">操作</div>
        </li>
        <order-item
          v-for="(item, index) in orderList"
          :key="item.id"
          :itemData="item"
          :itemIndex="index"
          :type="type"
        ></order-item>
        <noData v-show="isEmptyList"></noData>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import OrderItem from "../OrderItem";
export default {
  name: "OrderTable",
  components: { OrderItem, noData: () => import("@/components/noData.vue") },
  props: {
    type: { type: String, default: "全部订单" },
    orderList: { type: Array, default: () => [] },
  },
  data() {
    return {};
  },

  watch: {},
  computed: {
    ...mapGetters(["getCheckNum", "getTotalPrice"]),
    isAllCheck: {
      get() {
        return this.$store.getters.getIsAllCheck;
      },
      set(val) {
        this.checkAll(val);
      },
    },
    isEmptyList() {
      return this.orderList.length === 0;
    },
  },
  mounted() {},
  methods: {
    ...mapActions(["updateShoppingCart", "deleteShoppingCart", "checkAll"]),
    goPreOrder() {
      if (this.getCheckNum === 0) {
        this.$message.error("请至少选择一件商品");
        return;
      }
      this.$router.push("/cart/preorder");
    },
  },
};
</script>

<style scoped lang="scss">
/* 购物车主要内容区CSS */
.cart-table-wrap.content {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  height: auto;
  background-color: #fffefd;
  ul ::v-deep {
    background-color: #fffefd;
    color: #424242;
    line-height: 52px;
    .header {
      height: 52px;
      color: #424242;
      border-bottom: 1px solid #f2f2f2;
    }

    .goods-info {
      // width: 48%;
      min-width: 480px;
      display: flex;
      align-items: center;
      div {
        display: inline-block;
      }
      .order-cover {
        width: 122px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 90px;
          height: 90px;
        }
        .el-image__error {
          width: 90px;
          height: 90px;
          text-align: center;
          line-height: 90px;
          border-radius: 8px;
        }
      }
      .order-name {
        align-self: flex-start;
        margin-left: 4px;
        width: 360px;
      }
      .order-price {
        margin-left: 8px;
        width: 120px;
      }
    }
    .order-item {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      border-bottom: 1px solid #f2f2f2;
      // padding: 20px;
      font-size: 14px;
      .order-info {
        display: flex;
        justify-content: space-between;
        width: 100%;
        background-color: #f2f2f2;
        line-height: 40px;
        padding: 0 16px;
        .order-time {
          padding-left: 16px;
        }
        .right-action {
          margin-right: 32px;
        }
        .order-number {
          cursor: pointer;
        }
      }
      .goods-detail {
        display: flex;
        align-items: center;
        margin: 8px 0;
        .goods-info {
          .order-cover {
            cursor: pointer;
            height: 112px;
            img {
              margin: 0 auto;
            }
          }
          .order-name {
            line-height: normal;
            margin-top: 16px;
            span {
              cursor: pointer;
              &:hover {
                color: #2e9adb;
              }
            }
          }
        }
      }
      .action-wrap {
        div {
          cursor: pointer;
          line-height: normal;
          padding: 6px;
          &:hover {
            color: #2e9adb;
          }
        }
      }
    }

    .order-price,
    .order-pay,
    .order-status {
      text-align: center;
    }
    .order-status {
      &.waitPay {
        color: #ff5353;
      }
      &.waitEva {
        color: #f6a200;
      }
      &.complete {
        color: #2e9adb;
      }
      &.cancel {
        color: #999999;
      }
    }
    .order-action {
      text-align: center;
      .order-btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        color: #ffffff;
        padding: 0;
        background: #2e9adb;
        border-radius: 6px;
      }
    }
    .price-span {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      &::before {
        content: "¥";
      }
      &.weight {
        color: #333333;
      }
    }
  }
}
</style>
